import { imageFromUuid } from "../../helpers/utility";
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { BtnComponent } from "../button";
import ShareOptions from "../../pages/share";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useMemo, useState } from "react";
import { CheckBox } from "../reactHookFormFields/checkbox";
import { useForm } from "react-hook-form";
import useSendPdfToChat from "../../hooks/useSendPdfToChat";
import { useMarkDocumentStatusMutation } from "../../services/chatService";
import { toast } from "react-toastify";

const officeMimeTypes = [
  'application/msword',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

const officeExtensions = ['doc', 'docx', 'xls', 'xlsx'];

const isOfficeFile = (file) => {
  const extension = file?.title?.split('.').pop()?.toLowerCase();
  return officeMimeTypes.includes(file?.mime_type) || officeExtensions.includes(extension);
};

const getOfficeViewerUrl = (fileUrl) => {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
};

export const PdfViewer = ({data, uuid, file, closeHandler, isShowLinkToPatientChartWithImage=false, showMarkReview = false, messageId, pid, location_id }) => {
  const {sendPdfToChat, isSending} = useSendPdfToChat();

  const {control} = useForm();
  let url = imageFromUuid(uuid);
  const [isOpenShareEfax, setIsOpenShareEfax] = useState(false);
  const groupChatContext = useGroupChatContext();
  const {authData} = useMemo(() => ({
    authData: groupChatContext.authData,
  }));
  const [markDocumentStatus] = useMarkDocumentStatusMutation();
  const [loadingStatus, setLoadingStatus] = useState(null);
  const openInNewTab = () => {
    window.open(url, "_blank");
  };

  const shareViaEfax = () => { 
    setIsOpenShareEfax(true);
  };
  const markDocumentStatusHandler = async (status) => {
      try {
        setLoadingStatus(status);
    
        const res = await markDocumentStatus({
          attachment_id: messageId,
          status: status,
        }).unwrap();
    
        const message = res?.response?.msg;
    
        if (message) {
          toast.success(message);
        }
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setLoadingStatus(null);
      }
    };

  const handleLinkToPatientChart = async (e) => {
    if (data?.files?.length > 0) {
      let sendingFiles = data?.files.map(file => ({ ...file }));
      sendingFiles[0].is_link_to_patient_chart = e.target.checked;
      await sendPdfToChat(sendingFiles, { pid, location_id });
      closeHandler();
    }
  }

  return (
    <>
      <PageDialogContent>
        {isOfficeFile(file) ? (
          <div className="relative h-full w-full">
            <iframe
              id="viewOfficeFrame"
              title={file?.title || "Office document preview"}
              width="100%"
              height="100%"
              frameBorder="1"
              src={getOfficeViewerUrl(url)}
            ></iframe>
            <div
              className="absolute bottom-0 left-0 right-0 h-9 bg-transparent"
              aria-hidden="true"
            />
          </div>
        ) : (
          <iframe
            id="viewPdfFrame"
            width="100%"
            height="100%"
            frameBorder="1"
            allow="autoplay"
            src={url}
          ></iframe>
        )}
      </PageDialogContent>
      <PageDialogFooter>
        <BtnComponent text="Close" btnType="default" onClick={closeHandler} />
        <BtnComponent text="Open in New Tab" onClick={openInNewTab} />
        {showMarkReview && (
          <>
            <BtnComponent
              text={loadingStatus === "reviewed" ? "Saving..." : "Mark Review"}
              onClick={() => markDocumentStatusHandler("reviewed")}
            />
        
            <BtnComponent
              text={loadingStatus === "followup" ? "Saving..." : "Follow-Up Request"}
              onClick={() => markDocumentStatusHandler("followed up")}
            />
          </>
        )}
        {isShowLinkToPatientChartWithImage && !data?.files[0]?.is_link_to_patient_chart && <CheckBox disabled={isSending} control={control} name="linkToPatientChart" title="Link to Patient Chart"  onChange={handleLinkToPatientChart}/>}
        {(data?.event_type == 'create_task' && authData?.is_provider) ?
          <>
            <BtnComponent onClick={shareViaEfax} text="Share via Efax" />
            <BtnComponent onClick={() => {}} text="Mark as completed & Assign Back" />
            <BtnComponent onClick={() => {}} text="Mark as completed" />
            <BtnComponent onClick={() => {}} text="Assign Back Task" />
          </>
        : null}
      </PageDialogFooter>

      {isOpenShareEfax ?
        <ShareOptions
          bulk={true}
          sharePreviewUrl={"messages/read_attachment?uuid"}
          printData={"printData"}
          setShowShareeFax={setIsOpenShareEfax}
          // userUniqueId={selectedFiles}
        />
        :
        null
      }
    </>
  );
};